import { RouteObject, Navigate } from 'react-router-dom';
import * as Pages from './appRoutes';
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';

// Define the application routes
export const appRoutes: RouteObject[] = [
  {
    path: '/',
    element: <Pages.Home />,
  },
  {
    path: '/companies',
    element: <Pages.Companies />,
  },
  {
    path: '/companies/:slug',
    element: <Pages.CompanyDetail />,
  },
  {
    path: '/companies/:slug/reviews',
    element: <Pages.CompanyReviews />,
  },
  {
    path: '/companies/:slug/salaries',
    element: <Pages.CompanySalaries />,
  },
  {
    path: '/companies/:slug/interviews',
    element: <Pages.CompanyInterviews />,
  },
  {
    path: '/companies/:slug/jobs',
    element: <Pages.CompanyJobs />,
  },
  {
    path: '/create-company',
    element: <Pages.CreateCompany />,
  },
  {
    path: '/jobs',
    element: <Pages.Jobs />,
  },
  {
    path: '/jobs/:companySlug/:jobSlug',
    element: <Pages.JobDetails />,
  },
  {
    path: '/jobs/:id', // Backwards compatibility for old URLs
    element: <Pages.JobDetails />,
  },
  {
    path: '/jobs/category/:category',
    element: <Pages.JobDetailsByFilter />,
  },
  {
    path: '/reviews',
    element: <Pages.Reviews />,
  },
  // Add individual review route
  {
    path: '/reviews/:id',
    element: <Pages.ReviewDetail />,
  },
  // Add company/role specific reviews
  {
    path: '/reviews/:companyId/:jobTitle',
    element: <Pages.ReviewsByCompanyAndRole />,
  },
  {
    path: '/salaries',
    element: <Pages.Salaries />,
  },
  // Add location-specific salary routes
  {
    path: '/salaries/:jobTitle/:location',
    element: <Pages.SalariesByLocation />,
  },
  {
    path: '/locations/:location',
    element: <Pages.TopCompaniesByLocation />,
  },
  {
    path: '/submit-salary',
    element: <Pages.SubmitSalary />,
  },
  {
    path: '/submit-review',
    element: <Pages.SubmitReview />,
  },
  {
    path: '/login',
    element: <Pages.Login />,
  },
  {
    path: '/register',
    element: <Pages.Register />,
  },
  // Redirect legacy auth paths
  {
    path: '/auth/login',
    element: <Navigate to="/login" replace />,
  },
  {
    path: '/auth/register',
    element: <Navigate to="/register" replace />,
  },
  {
    path: '/dashboard',
    element: <Navigate to="/admin" replace />,
  },
  // Redirect legacy company dashboard paths (without ID)
  {
    path: '/company/dashboard',
    element: <Navigate to="/companies" replace />,
  },
  {
    path: '/company-dashboard',
    element: <Navigate to="/companies" replace />,
  },
  {
    path: '/forgot-password',
    element: <Pages.ForgotPassword />,
  },
  {
    path: '/reset-password',
    element: <Pages.ResetPassword />,
  },
  {
    path: '/admin',
    element: <Pages.AdminDashboard />,
  },
  {
    path: '/admin/login',
    element: <Pages.AdminLogin />,
  },
  {
    path: '/admin/users',
    element: <Pages.AdminManagement />,
  },
  {
    path: '/admin/companies',
    element: <Pages.CompaniesManagement />,
  },
  {
    path: '/admin/jobs',
    element: <Pages.JobsManagement />,
  },
  {
    path: '/admin/salaries',
    element: <Pages.SalariesManagement />,
  },
  {
    path: '/admin/email-management',
    element: <Pages.EmailManagement />,
  },
  {
    path: '/profile',
    element: <ProtectedRoute><Pages.UserProfile /></ProtectedRoute>,
  },
  {
    path: '/settings',
    element: <ProtectedRoute><Pages.UserSettings /></ProtectedRoute>,
  },
  {
    path: '/community',
    element: <Pages.Community />,
  },
  {
    path: '/analytics',
    element: <Pages.Analytics />,
  },
  {
    path: '/faq',
    element: <Pages.FAQ />,
  },
  {
    path: '/about',
    element: <Pages.AboutUs />,
  },
  {
    path: '/privacy',
    element: <Pages.PrivacyPolicy />,
  },
  {
    path: '/terms',
    element: <Pages.TermsOfUse />,
  },
  {
    path: '/community-guidelines',
    element: <Pages.CommunityGuidelines />,
  },
  {
    path: '/top-companies',
    element: <Pages.TopCompanies />,
  },
  {
    path: '/categories',
    element: <Pages.CompanyCategories />,
  },
  {
    path: '/categories/:id',
    element: <Pages.CategoryDetail />,
  },
  {
    path: '/salary-calculator',
    element: <Pages.SalaryCalculator />,
  },
  {
    path: '/company-dashboard/:id',
    element: <Pages.CompanyDashboard />,
  },
  // Add QA Testing route
  {
    path: '/qa-testing',
    element: <Pages.QATesting />,
  },
  {
    path: '/search',
    element: <Pages.Search />,
  },
  {
    path: '*',
    element: <Pages.NotFound />,
  },
];
